//#region imports
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot} from '@angular/router';
import { ComponentCanDeactivate } from '@app/member-response-portal/interface/canComponentDeactivate';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '@app/member-response-portal/service/navigation.service';
import { UnsavedChangesDialogComponent } from '../shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';
//#endregion imports

export const PendingChangesGuard : CanDeactivateFn<ComponentCanDeactivate> = (component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot ) =>
 {
    const dialog : any = inject(MatDialog);
    const navigationService : any = inject(NavigationService);

    if (!navigationService.GetIgnoreCanDeactivate()) {

        const dialogRef : any = dialog.open(UnsavedChangesDialogComponent, {
            disableClose: true,
            width: '500px'
        });

        return dialogRef.afterClosed().pipe(
            take(1),
            map((result : boolean) => {
                if(!result){
                  navigationService.NavigateByUrl(currentState?.url)
                }
                return result;
            })
        );
    }

    return true;
}
